









































import { Component, Vue } from "vue-property-decorator";
import PhotoHeader from "@/components/organization/PhotoHeader.vue";
import Main from "@/components/organization/Main.vue";
import Paragraph from "@/components/organization/Paragraph.vue";
import HorizontalList from "@/components/organization/HorizontalList.vue";
import Speakers from "@/components/organization/Speakers.vue";
import Columns from "@/components/organization/Columns.vue";
import Organization from "@/components/organization/Names.vue";
import Supporters from "@/components/organization/Supporters.vue";
import speakers from "@/models/speakers";

@Component({
  components: {
    PhotoHeader,
    Main,
    HorizontalList,
    Paragraph,
    Speakers,
    Columns,
    Organization,
    Supporters
  }
})
export default class Programacao extends Vue {
    
    private hackaton: any;

    private events: any;

    constructor(){
      super();      


      
      this.hackaton = require('@/storage/programacao/hackaton').default;

      this.events = [
        
        {
          title: 'Lista de Checkpoints',
          description: '',
          activities: this.hackaton,
        },
      ];
    }


    mounted() {
      
      const itens = this.hackaton;

      for (const iterator of itens) {

        const caixa_texto = document.getElementById(iterator.id);
        const imagem = document.getElementById('img-' + iterator.id);

        imagem.addEventListener('mouseenter', () => {
          caixa_texto.style.visibility = 'visible';
        });

        imagem.addEventListener('mouseleave', () => {
          caixa_texto.style.visibility = 'hidden';
        })
      }      
    }    


}
